export const CURRENCY_SYMBOL_MAP = {
  UAH: '₴',
  USD: '$',
  EUR: '€',
  HUF: 'Ft',
};